import { Download } from "lucide-react";

export default function BrandGuideline() {
  const palette = [
    { name: "Primary", hex: "#005F8E" },
    { name: "Primary Dark", hex: "#003A5C" },
    { name: "Primary Light", hex: "#0086C6" },
    { name: "Accent", hex: "#00B4D8" },
    { name: "Accent Bright", hex: "#48CAE4" },
    { name: "Ocean Deep", hex: "#021B2F" },
    { name: "Section BG", hex: "#F0F8FF" },
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Identitas Visual</div>
        <h1 className="font-heading font-bold text-3xl lg:text-5xl text-[#003A5C]">Brand Guideline SILAING</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">Panduan penggunaan logo, palet warna, dan tipografi resmi portal Sistem Informasi Laut dan Ikan Terintegrasi.</p>
      </div>

      <section className="mb-12">
        <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold">01</div>
            <h2 className="font-heading font-bold text-2xl text-[#003A5C]">Logo Asset Pack</h2>
          </div>
          <a href="/assets/silaing/silaing-logo-pack.png" download className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#005F8E] hover:bg-[#003A5C] text-white text-sm font-semibold">
            <Download className="w-4 h-4" /> Unduh Logo
          </a>
        </div>
        <div className="bg-white rounded-3xl border border-slate-100 shadow-md p-6 lg:p-10">
          <img src="/assets/silaing/silaing-logo-pack.png" alt="SILAING Logo Asset Pack" className="w-full max-w-3xl mx-auto object-contain" />
        </div>
      </section>

      <section className="mb-12">
        <div className="mb-5">
          <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold">02</div>
          <h2 className="font-heading font-bold text-2xl text-[#003A5C]">Palet Warna</h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {palette.map((c) => (
            <div key={c.hex} className="bg-white rounded-2xl border border-slate-100 overflow-hidden shadow-sm">
              <div className="aspect-[4/3]" style={{ background: c.hex }} />
              <div className="p-4">
                <div className="font-heading font-bold text-[#003A5C] text-sm">{c.name}</div>
                <div className="text-xs text-slate-500 font-mono mt-0.5">{c.hex}</div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div className="mb-5">
          <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold">03</div>
          <h2 className="font-heading font-bold text-2xl text-[#003A5C]">Tipografi</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          <div className="bg-white rounded-2xl border border-slate-100 p-6">
            <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Heading</div>
            <div className="font-heading font-bold text-3xl text-[#003A5C]">Poppins</div>
            <div className="text-xs text-slate-500 mt-3">Digunakan untuk judul, headline, dan section title.</div>
          </div>
          <div className="bg-white rounded-2xl border border-slate-100 p-6">
            <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Body</div>
            <div className="font-body font-normal text-2xl text-[#003A5C]">Inter</div>
            <div className="text-xs text-slate-500 mt-3">Digunakan untuk paragraf, deskripsi, dan konten umum.</div>
          </div>
          <div className="bg-white rounded-2xl border border-slate-100 p-6">
            <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Accent</div>
            <div className="font-accent font-semibold text-2xl text-[#003A5C]">Montserrat</div>
            <div className="text-xs text-slate-500 mt-3">Digunakan untuk label, tagline, dan aksen visual.</div>
          </div>
        </div>
      </section>
    </div>
  );
}
